import { IMatchCodesAction } from './matchCodesActions';
import { MatchCodesActionType } from './matchCodesActionTypes';

export interface MatchCodesState {
    matchCodes: Record<string, string>;
    lastFetchedAt: number | null;
    loading: boolean;
}

export const initialState: MatchCodesState = {
    matchCodes: {},
    lastFetchedAt: null,
    loading: false
};

export default function (state: MatchCodesState = initialState, action: IMatchCodesAction): MatchCodesState {
    switch (action.type) {
        case MatchCodesActionType.START_REQUEST:
            return { ...state, loading: true };
        case MatchCodesActionType.LOAD_SUCCESS:
            return {
                ...state,
                loading: false,
                matchCodes: action.matchCodes ? action.matchCodes : {},
                lastFetchedAt: new Date().getTime()
            };
        case MatchCodesActionType.LOAD_ERROR:
            return { ...state, loading: false, matchCodes: {}, lastFetchedAt: null };
        case MatchCodesActionType.RESET_CACHE:
            return { ...state, matchCodes: {}, lastFetchedAt: null };
        default:
            return state;
    }
}
